var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itemAba",class:{'is-loading': _vm.loading}},[(!_vm.loading)?_vm._t("default"):_c('sl-loading',{attrs:{"content":"","loading-style":"coffe__DELETED"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }